import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, of } from 'rxjs';

import { type MunicipalitySuggestion } from '../models/valuation-request.model';
import {
  buildRuianQueryParams,
  mapRuianSuggestions,
  type RuianQueryResponse
} from '../utils/ruian-search.util';

@Injectable({ providedIn: 'root' })
export class MunicipalityService {
  private readonly baseUrl = 'https://ags.cuzk.gov.cz/arcgis/rest/services/RUIAN/MapServer/12/query';

  constructor(private readonly http: HttpClient) {}

  search(query: string): Observable<MunicipalitySuggestion[]> {
    const normalizedQuery = query.trim();

    if (normalizedQuery.length < 2) {
      return of([]);
    }

    return this.http.get<RuianQueryResponse>(this.baseUrl, {
      params: buildRuianQueryParams(normalizedQuery)
    }).pipe(
      map((response) => mapRuianSuggestions<MunicipalitySuggestion>(response.features))
    );
  }
}
